export default "__VITE_ASSET__BWo1s4NZ__"